mainApp.directive('networkRules', function() {
    return {
        templateUrl: '/public/directives/networkRules.html',
        scope: {
            // external icons optional
            networkRulesProperties: '=?'
        },
        controller:  ['$scope', '$timeout', '$state', "IconsService", "GeneralUtilsService", "LocationService", "$filter", "NetworkRulesService", '$element', 'FieldsService', function($scope, $timeout, $state, IconsService, GeneralUtilsService, LocationService, $filter, NetworkRulesService, $element, FieldsService) {
            $scope.isSystemLogin = window.isSystemLogin;
            var origNetworkRules;
            var indexesChangedOrder = [];
            var currentInlineActionsItem;
            const FieldTypes = FieldsService.getFieldTypes();
            const fieldsForType = {
                WAN: {
                    what:{
                        name: 'App/Category',
                        id: 'what',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'Applications',
                                field: FieldTypes.wanApps,
                            },
                            {
                                name: 'Custom Applications',
                                field: FieldTypes.customApplications,
                            },
                            {

                                name: 'Categories',
                                field: FieldTypes.categories,
                            },
                            {
                                name: 'Custom Categories',
                                field: FieldTypes.customCategories,
                            },
                            {
                                name: 'Fully Qualified Domain Name',
                                field: FieldTypes.FQDN,
                            },
                            {
                                name: 'Top Level Domain',
                                field: FieldTypes.TLD,
                            },
                            {
                                name: 'Custom Service (By IP)',
                                field: FieldTypes.customService,
                            },
                            {
                                name: 'Services',
                                field: FieldTypes.services
                            },
                            {
                                name: 'Ports',
                                field: FieldTypes.ports
                            }]
                    },
                    from: {
                        name: 'From',
                        id: 'from',

                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'Site',
                                field: FieldTypes.sites
                            }, {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            }, {
                                name: 'Groups',
                                field: FieldTypes.groups
                            }, {
                                name: 'Hosts',
                                field: FieldTypes.subnets
                            }, {
                                name: 'Networks',
                                field: FieldTypes.ipRanges
                            }, {
                                name: 'DS User',
                                field: FieldTypes.dsUser
                            }, {
                                name: 'Floating Ranges',
                                field: FieldTypes.floatingIps
                            }, {
                                name: 'IP Address',
                                field: FieldTypes.ips
                            }]
                    },
                    to: {
                        name: 'To',
                        id: 'to',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'Site',
                                field: FieldTypes.sites
                            }, {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            }, {
                                name: 'Groups',
                                field: FieldTypes.groups
                            }, {
                                name: 'Hosts',
                                field: FieldTypes.subnets
                            }, {
                                name: 'Networks',
                                field: FieldTypes.ipRanges
                            }, {
                                name: 'DS User',
                                field: FieldTypes.dsUser
                            }, {
                                name: 'Floating IP',
                                field: FieldTypes.floatingIps
                            }]
                    },
                },
                Internet: {
                    what:{
                        name: 'App/Category',
                        id: 'what',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'Applications',
                                field: FieldTypes.internetApps,
                            },
                            {
                                name: 'Custom Applications',
                                field: FieldTypes.customApplications,
                            },
                            {

                                name: 'Categories',
                                field: FieldTypes.categories,
                            },
                            {
                                name: 'Custom Categories',
                                field: FieldTypes.customCategories,
                            },
                            {
                                name: 'Fully Qualified Domain Name',
                                field: FieldTypes.FQDN,
                            },
                            {
                                name: 'Top Level Domain',
                                field: FieldTypes.TLD,
                            },
                            {
                                name: 'Custom Service (By IP)',
                                field: FieldTypes.customService,
                            },
                            {
                                name: 'Services',
                                field: FieldTypes.services
                            },
                            {
                                name: 'Ports',
                                field: FieldTypes.ports
                            }]
                    },
                    from: {
                        name: 'From',
                        id: 'from',

                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'Site',
                                field: FieldTypes.sites
                            }, {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            }, {
                                name: 'Groups',
                                field: FieldTypes.groups
                            }, {
                                name: 'Hosts',
                                field: FieldTypes.subnets
                            }, {
                                name: 'Networks',
                                field: FieldTypes.ipRanges
                            }, {
                                name: 'DS User',
                                field: FieldTypes.dsUser
                            }, {
                                name: 'Floating Ranges',
                                field: FieldTypes.floatingIps
                            }, {
                                name: 'IP Address',
                                field: FieldTypes.ips
                            }]
                    },
                    to: {
                        name: 'To',
                        id: 'to',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'Site',
                                field: FieldTypes.sites
                            }, {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            }, {
                                name: 'Groups',
                                field: FieldTypes.groups
                            }, {
                                name: 'Hosts',
                                field: FieldTypes.subnets
                            }, {
                                name: 'Networks',
                                field: FieldTypes.ipRanges
                            }, {
                                name: 'DS User',
                                field: FieldTypes.dsUser
                            }, {
                                name: 'Floating IP',
                                field: FieldTypes.floatingIps
                            }]
                    },
                },
            };

            for (let key in fieldsForType) {
                fieldsForType[key].whatException = angular.copy(fieldsForType[key].what);
                fieldsForType[key].whatException.id = 'whatException';
                fieldsForType[key].toException = angular.copy(fieldsForType[key].to);
                fieldsForType[key].toException.id = 'toException';
                fieldsForType[key].fromException = angular.copy(fieldsForType[key].from);
                fieldsForType[key].fromException.id = 'fromException';
            }


            $scope.datamodified = false;
            $scope.icons = IconsService.getIcons();

            $scope.$watch('networkRules', function(newValue, oldValue) {
                if($scope.networkRulesProperties && oldValue){
                    if (!_.isEqual(newValue, oldValue)) {
                        if(origNetworkRules && $scope.networkRules){
                            // was changed is an object inside a property telling if network rule was changed
                            $scope.networkRulesProperties.wasChanged = !isNetworkRuleArrEquals(origNetworkRules,$scope.networkRules);
                            $scope.networkRulesProperties.networkRules = $scope.networkRules;
                            if(!$scope.networkRulesProperties.onNetworkRulesSave)
                                $scope.networkRulesProperties.onNetworkRulesSave = onNetworkRulesSave;
                        }
                    }
                }
            }, true);

            function isNetworkRuleArrEquals(networkRuleArr1,networkRuleArr2) {
                if(networkRuleArr1.length != networkRuleArr2.length){
                    return false;
                }
                else{
                    for ( var index = 0; index < networkRuleArr1.length; index++) {
                        if(!isNetworkRuleEqual(networkRuleArr1[index],networkRuleArr2[index])){
                            return false;
                        }
                    }
                }
                return true;
            }

            // this properties will be checked in order to determine if rules are equal
            var equalityProperties = ['allocatedIps','allocatedIpsIds','creationDate','crossConnectNat','description'
                ,'fqdns','from','fromException','id','itemsToAdd','itemsToDelete','lastModified','locations'
                ,'packetLossMitigationEnabled','primaryTransport','secondaryTransport','priority','publishedIpsIds'
                ,'routeType','routeVia','ruleEnabled','ruleType','sslAcceleration','to','toException','topLevelDomains'
                ,'topLevelDomainsException','what','whatException','qosPriority','activeTcpAcceleration'
                ,'primarySocketInterfaceRoleForPrimaryTransport','secondarySocketInterfaceRoleForPrimaryTransport'
                ,'primarySocketInterfaceRoleForSecondaryTransport','secondarySocketInterfaceRoleForSecondaryTransport'];

            function isNetworkRuleEqual(rule1,rule2) {
                var isValid = true;
                for (var ind = 0; ind < equalityProperties.length && isValid; ind++) {
                    isValid = isValid && angular.equals(rule1[equalityProperties[ind]], rule2[equalityProperties[ind]]);
                }
                return isValid;
            }

            /**
             * this callback will be applied after tha account was saved with the new network rules
             * copy the current network rules since they were just saved , turn off the was changed
             * boolean
             */
            function onNetworkRulesSave() {
                $scope.networkRulesProperties.wasChanged = false;
                $scope.datamodified = new Date().getTime();
                delete $scope.networkRulesProperties.networkRules;
            }

            /**
             * initiate any undefined properties in order
             * to display correctly to the user
             * @param rule
             */
            function initiateUndefinedProperties(rule) {
                if (!rule.what) {
                    rule.what = [];

                }

                if (!rule.from)
                    rule.from = [];

                rule.allocatedIps.forEach(function (allocatedIp) {
                    allocatedIp.display_name = getAllocatedIpDisplayName(allocatedIp);
                });

                if (rule.crossConnectNat) {
                    rule.crossConnectNat.forEach(function (publishedIP) {
                        if (!publishedIP.networkRules) {
                            publishedIP.networkRules = [];
                        }
                        publishedIP.display_name = publishedIP.ipRange + ":" + 'Published';
                    });
                }
            }

            function getAllocatedIpDisplayName(allocatedIp) {
            	if (!LocationService.hasLocationForAccount($state.params.accountId)) {
            		$timeout(function() {
                    	getAllocatedIpDisplayName(allocatedIp);
                    }, 50, false);
                    return;
            	}
                var location = LocationService.getPopLocationViaLocationId($state.params.accountId, allocatedIp.locationId) || allocatedIp.location;
                if (location && location.name) {
                    allocatedIp.name = location.name;
                }
                return allocatedIp.ip + ":" + allocatedIp.name;
            }

            function checkLocationForAccount(){
                if (!LocationService.hasLocationForAccount($state.params.accountId)) {
                	$timeout(function() {
                    	checkLocationForAccount();
                    }, 50, false);
                    return;
                }
                $scope.allocatedIpsdatamodified = new Date().getTime();
            }

            function loadQosPriorities(){
                store.fetch({
                    path: '/qosPriorities',
                    queryParams: {'accountId': $state.params.accountId || ""},
                    success: function (data) {
                        if(data){
                            $scope.qosPriorities = [];
                            data.sort(function (p1,p2) {return parseInt(p1)-parseInt(p2)});
                            data.forEach(function (policy) {$scope.qosPriorities.push({value:policy, label:"P"+policy})});
                            $scope.qosPriorities.push({value: 255, label: "Default"});
                            $scope.networkRulesConfig.qosPriorities = $scope.qosPriorities;
                        }
                    }
                });
            }

            function loadTrafficOptions() {
                NetworkRulesService.getNetworkTrafficOptions($state.params.accountId, function(data) {
                    $scope.networkRulesConfig.transports = data;
                });
            }

            function loadNICOptions() {
                NetworkRulesService.getNetworkNICOptions($state.params.accountId, function(data) {
                    $scope.networkRulesConfig.NICs = data;
                });
            }

            function init() {
                if (!$scope.$root || !$scope.$root.tags) {
                    $timeout(function(){
                        init();
                    }, 20);

                    return;
                }

                LocationService.getPopLocations($state.params.accountId);
                loadQosPriorities();
                checkLocationForAccount();
                loadTrafficOptions();
                loadNICOptions();
                $scope.networkRulesConfig = {
                    dataURL : function(){
                        return "/getRules?accountId=" + $state.params.accountId + "&rulesType=NETWORK_RULES";
                    },
                    removeURL: function() {
                        return 'deleteRules';
                    },
                    sortList: [{sortField: 'priority', sortDir: 'ASC'}],
                    items:[],
                    fields : [
                        {'label':'s','path':'arrows','template':'<div class="arrows-wrapper">'+
                                                                '<a title="Move Priority Up" role="button" ng-disabled="item.priority === 1" ng-click="tableConfig.changePriority(\'up\', item.priority, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-up"></use></svg></a>'+
                                                                '<a title="Move Priority Down" role="button" ng-disabled="item.priority === items.length" ng-click="tableConfig.changePriority(\'down\', item.priority, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-down"></use></svg></a>'+
                                                                '</div>'},
                        {'label':'a','path':'item','template':'<single-network-rule ng-if="tableConfig.transports && tableConfig.NICs"></single-network-rule>'},
                    ],
                    alternativeHead: [
                        {'label': '#', 'path': 'priority', noSort: true},
                        {'label': 'Type', 'path': 'type', noSort: true},
                        {'label': 'Name', 'path': 'description', noSort: true},
                        {'label': 'What', 'path': 'what', noSort: true},
                        {'label': 'From', 'path': 'from', noSort: true},
                        {'label': 'To', 'path': 'to', noSort: true},
                        {'label': '', 'path': '', noSort: true},
                        {'label': '', 'path': '', noSort: true},
                    ],
                    parseData: function(data){
                        $scope.networkRules = data.rules;
                        $scope.networkRules.forEach(function (rule) {
                            initiateUndefinedProperties(rule);
                            initiateCrossConnectAndAllocatedIps(rule);
                            //rule.what = rule.whatBuckets.what.items; // the what field is now stored in the whatBuckets object
                        });
                        origNetworkRules = angular.copy($scope.networkRules);
                        return $scope.networkRules;
                    },
                    clientSideSearch: true,
                    type : 'NETWORK_RULES',
                    selectedItems:[],
                    pageSize:999,
                    actions: ['remove'],
                    hideCheckboxes: true,
                    processData: function(items) {
                    },
                    whatExceptionEntryListSelect: function (id, item) {
                        $scope.whatExceptionEntryListSelect(id, item);
                    },
                    fromExceptionEntryListSelect: function (id, item, direction) {
                        $scope.fromExceptionEntryListSelect(id, item, direction);
                    },
                    getConfigFromType: function (item) {
                        $scope.getConfigFromType(item);
                    },
                    addFromItems: function () {
                        $scope.addFromItems();
                    },
                    fromEntryListSelect: function(id, item, direction) {
                        $scope.fromEntryListSelect(id, item, direction);
                    },
                    whatEntryListSelect: function(id, item) {
                        $scope.whatEntryListSelect(id, item);
                    },
                    changePriority: function(direction, priority, $event) {
                        var index = priority > 0 ? priority - 1 : priority;
                        $event.stopPropagation();
                        var that = this;
                        var $thisEl = $($element[0]);
                        $thisEl.find('.order-change').removeClass('order-change');
                        $timeout(function() {
                            if ((index === 0 && direction === 'up') || (index === that.items.length - 1  && direction === 'down') || !that.items[index]) {
                                return;
                            }

                            that.items[index].priority = that.items[index].priority + (direction === 'up' ? - 1 : 1);
                            if (index !== 0 && direction === 'up') {
                                that.items[index - 1].priority = that.items[index - 1].priority + 1;
                                swapRules(that.items,index,index - 1);
                            }
                            if (index !== that.items.length - 1  && direction !== 'up') {
                                that.items[index + 1].priority = that.items[index + 1].priority -1;
                                swapRules(that.items,index,index + 1);
                            }

                            that.refreshViewItems = new Date().getTime();

                            indexesChangedOrder.forEach(function(i) {
                                $thisEl.find('.row-' + i).first().addClass('order-change');
                            });

                            indexesChangedOrder = [];
                        }, 0);
                    },
                    locationEntryListSelect: function(id, item) {
                        $scope.locationEntryListSelect(id, item);
                    },
                    clientSideSort: false,
                    ipEntryListSelect: function(id, item) {
                        $scope.ipEntryListSelect(id, item);
                    },
                    icons: IconsService.getIcons('policy'),
                    titleSearch: 'Network Rules',
                    searchPredicate: function(item, valueToSearch) {
                        return (item.description.toLowerCase().includes(valueToSearch)) ||
                                (Object.values(item.from).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
                                (Object.values(item.to).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
                                (Object.values(item.what).some(x => x?.display_name?.toLowerCase().includes(valueToSearch)));
                    },
                    onSelect: function(index) {

                    },
                    onIpEntryListRemove: function (item) {
                        item.crossConnectNat = [];
                        item.allocatedIps =[];
                        item.allocatedIpsIds = [];
                        item.publishedIpsIds = [];
                        item.allocatedAndCrossConnectIps.forEach(function (elem) {
                            if(elem.type == "CROSSCONNECTNAT"){
                                item.crossConnectNat.push(elem);
                                item.publishedIpsIds.push(elem.id);
                            }
                            else{
                                item.allocatedIps.push(elem);
                                item.allocatedIpsIds.push(elem.id);
                            }
                        });
                    },
                    multiSelect: true,
                    deselect: true,
                    noAutoSelect: true,
                    nameField: 'description',
                    toOptions: [
                        {
                            value: "Internet",
                            label: "Internet",
                        },
                        {
                            value: "WAN",
                            label: "WAN",
                        },
                    ],
                    routeTypes: [
                         {
                             value: "NONE",
                             label: "None",
                         },
                         {
                             value: "VIA",
                             label: "Route Via",
                         },
                         {
                             value: "NAT",
                             label: $scope.$root && $scope.$root.tags && $scope.$root.tags.indexOf('ISP_CONFIG_IPS') > -1 ? "NAT & Route" : "NAT"
                         }
                    ],
                    specialActions: [
                        {
                            icon: "plus",
                            tooltip: "Add",
                            id: "add-networkRule",
                            innerActions: [
                                {
                                    icon: "Internet",
                                    name: "Internet",
                                    func: function(selectedItems, tableConfig) {
                                        addNewCreatedRule(tableConfig, 'Internet');
                                    }
                                },
                                {
                                    icon: "WAN",
                                    name: "WAN",
                                    func: function(selectedItems, tableConfig) {
                                        addNewCreatedRule(tableConfig, 'WAN');
                                    }
                                }
                            ],
                            func: function(selectedItems,tableConfig,$event) {
                                var targetElId = 'inner-action-add-networkRule';
                                $scope.$root.toggleDropDown(targetElId, $event);
                            }
                        }
                    ],
                    innerLoader: true,
                    openInlineActions: function(item, $event) {
                        $event.stopPropagation();
                        $scope.$root.$emit("$togglePopup", "networkrules-inline-actions", 'inline-actions_' + item.id, {leftMod:$scope.$root.menuClosed ? -46 : -205});
                        currentInlineActionsItem = item;
                    },
                    selectionFields: fieldsForType,
                    stickyHead: true,
                };

                $scope.addWanRuleAbove = function(item) {
                    addNewCreatedRule($scope.networkRulesConfig, 'WAN', $scope.networkRulesConfig.items.indexOf(currentInlineActionsItem));
                    $scope.$root.$emit("$closePopup", "networkrules-inline-actions");
                    currentInlineActionsItem = null;
                };
                $scope.addWanRuleBelow = function(item) {
                    addNewCreatedRule($scope.networkRulesConfig, 'WAN', $scope.networkRulesConfig.items.indexOf(currentInlineActionsItem)+1);
                    $scope.$root.$emit("$closePopup", "networkrules-inline-actions");
                    currentInlineActionsItem = null;
                };

                $scope.addInternetRuleAbove = function(item) {
                    addNewCreatedRule($scope.networkRulesConfig, 'Internet', $scope.networkRulesConfig.items.indexOf(currentInlineActionsItem));
                    $scope.$root.$emit("$closePopup", "networkrules-inline-actions");
                    currentInlineActionsItem = null;
                };
                $scope.addInternetRuleBelow = function(item) {
                    addNewCreatedRule($scope.networkRulesConfig, 'Internet', $scope.networkRulesConfig.items.indexOf(currentInlineActionsItem)+1);
                    $scope.$root.$emit("$closePopup", "networkrules-inline-actions");
                    currentInlineActionsItem = null;
                };

                var getNewRule = function(tableConfig, ruleName, ruleType, position) {
                    var numOfItems = tableConfig.items.length;
                    return {
                        name: ruleName,
                        id: GeneralUtilsService.getRandomId(),
                        description: 'Network Rule ' + (numOfItems + 1),
                        from:[],
                        ruleEnabled: true,
                        to: [],
                        locations: [],
                        allocatedIps: [],
                        priority: (position || position === 0? position : numOfItems) + 1,
                        whatException: [],
                        fromException: [],
                        toException: [],
                        qosPriority: 255,
                        what: [],
                        toType: ruleType,
                        primaryTransport: NetworkRulesService.getValueOfDefault(tableConfig.transports[ruleType], NetworkRulesService.defaultsEnum.PRIMARY),
                        secondaryTransport: NetworkRulesService.getValueOfDefault(tableConfig.transports[ruleType], NetworkRulesService.defaultsEnum.SECONDARY),
                        primarySocketInterfaceRoleForPrimaryTransport: NetworkRulesService.getValueOfDefault(tableConfig.NICs[ruleType], NetworkRulesService.defaultsEnum.PRIMARY),
                        secondarySocketInterfaceRoleForPrimaryTransport: NetworkRulesService.getValueOfDefault(tableConfig.NICs[ruleType], NetworkRulesService.defaultsEnum.SECONDARY),
                        primarySocketInterfaceRoleForSecondaryTransport: NetworkRulesService.getValueOfDefault(tableConfig.NICs[ruleType], NetworkRulesService.defaultsEnum.PRIMARY),
                        secondarySocketInterfaceRoleForSecondaryTransport: NetworkRulesService.getValueOfDefault(tableConfig.NICs[ruleType], NetworkRulesService.defaultsEnum.SECONDARY),
                        routeType: 'NONE'
                    };
                };

                var addNewCreatedRule = function(tableConfig, ruleType, position) {
                    if ($scope.networkRules) {
                        var newRule = getNewRule(tableConfig, ruleType + ' networkRule', ruleType, position);

                        if ($scope.networkRulesProperties.defaultTcpAccelerationExternal && ruleType=='Internet') {
                            newRule.activeTcpAcceleration = $scope.networkRulesProperties.defaultTcpAccelerationExternal;
                        }
                        if ($scope.networkRulesProperties.defaultTcpAccelerationInternal && ruleType=='WAN') {
                            newRule.activeTcpAcceleration = $scope.networkRulesProperties.defaultTcpAccelerationInternal;
                        }

                        let addRuleToBottom = !position && position !== 0;

                        if (addRuleToBottom) {
                            $scope.networkRules.push(newRule);
                        } else {
                            $scope.networkRules.splice(position, 0, newRule);
                            for (var i = position + 1;$scope.networkRules[i];i++) {
                                $scope.networkRules[i].priority++;
                            }
                        }
                        $scope.$root.closeDropDown('inner-action-add-networkRule');

                        $timeout(function() {
                            if (addRuleToBottom) {
                                let $document = $(document);
                                $document.scrollTop($document.height());
                            }
                        }, 0, false);
                    }
                };
            }

            var swapRules = function(arr, indexA, indexB) {
                var temp = arr[indexA];
                arr[indexA] = arr[indexB];
                arr[indexB] = temp;
                indexesChangedOrder.push(indexA);
                indexesChangedOrder.push(indexB);
            };

            var initiateCrossConnectAndAllocatedIps = function(item){
                item.allocatedAndCrossConnectIps = [];
                if(item.allocatedIps){
                    item.allocatedIps.forEach(function (elem) {
                        item.allocatedAndCrossConnectIps.push(elem);
                    });
                }
                if(item.crossConnectNat){
                    item.crossConnectNat.forEach(function (elem) {
                        item.allocatedAndCrossConnectIps.push(elem);
                    });
                }
            };

            init();

            // if SDWAN_OPTIMIZED_ACCESS tag, then new routing
            if ($scope.$root && $scope.$root.tags && $scope.$root.tags.indexOf('SDWAN_OPTIMIZED_ACCESS') > -1) {
                 $scope.networkRulesConfig.routeTypes.push({
                                                               value: "OPTIMIZED",
                                                               label: "Optimized Access"
                                                           });
                                                           }

            /**
             * this method for selecting the what exception entry list selection open the popup and initiating the
             * properties
             * @param id
             * @param item
             */
            $scope.whatExceptionEntryListSelect = function (id,item) {
                $scope.currentItem = item;
                // setting the default category for the services dialog
                $scope.showAllocatedIps='categories';
                $scope.addServiceConfig.appsConfig.dataFilter.selectedOption = item.toType;
                $scope.addServiceConfig.servicesConfig.dataFilter.selectedOption = item.toType;
                $scope.appsDataModified = new Date().getTime();
                $scope.servicesDataModified = new Date().getTime();
                initiateCurrentItems(item);
                populateAny(item.whatException);

                // when opening the dialog - check all existing items
                $scope.addServiceConfig.categoriesConfig.selectedItems = [];
                $scope.addServiceConfig.appsConfig.selectedItems = [];
                $scope.addServiceConfig.servicesConfig.selectedItems = [];
                $scope.addServiceConfig.newIPApplication.ips = "";
                $scope.addServiceConfig.newIPApplication.autoGeneratedIPSec = "";
                $scope.addServiceConfig.freeText = "";
                $scope.addServiceConfig.fqdnFreeText = "";
                $scope.addServiceConfig.allowAnyItems = false;

                item.whatException.forEach(function(service){
                    if(!service.ip && service.display_name != 'Any' ){
                        if (service.type === 'Service') {
                            // Service
                            $scope.addServiceConfig.servicesConfig.selectedItems.push(service);
                        } else if(service.type === 'AppCategory'){
                            // Category
                            $scope.addServiceConfig.categoriesConfig.selectedItems.push(service);
                        } else if (service.type != 'FQDN' && service.type != 'TLD' && service.type != 'PORT') {
                            // APP
                            service.type = 'App'; // Fill type on existing configuration
                            $scope.addServiceConfig.appsConfig.selectedItems.push(service);
                        }
                    }
                });
                $scope.addServiceConfig.freeText = item.whatException.filter(function (dest) {return dest.type === "TLD"}).map(function (dest) {return dest.id}).join();
                $scope.addServiceConfig.fqdnFreeText = item.whatException.filter(function (dest) {return dest.type === "FQDN"}).map(function (dest) {return dest.id}).join();
                $scope.addServiceConfig.ports = item.whatException.filter(function (dest) {return dest.type === "PORT"}).map(function (dest) {return dest.id}).join();
                // only the custom generated
                $scope.addServiceConfig.newIPApplication.ips = item.whatException.filter(function(serv) {return serv.ip && !serv.autoGenerated;}).map(function (service) {return service.display_name;}).join();
                // only the auto generated for ipsec services
                $scope.addServiceConfig.newIPApplication.autoGeneratedIPSec = item.whatException.filter(function(serv) {return serv.ip && serv.autoGenerated;}).map(function (service) {return service.display_name;}).join();

                $scope.entrySelectException = true;
                $scope.$root.openPopup("networkingRulesServicesDlg");
            };

            /**
             * this method for selecting the from entry list selection open the popup and initiating the
             * properties
             * @param id
             * @param item
             * @param direction
             */
            $scope.fromExceptionEntryListSelect = function (id, item, direction) {
                $scope.currentDirection = direction;
                $scope.currentItem = item;
                $scope.showItem = 'group';
                initiateCurrentItems(item);

                performAddEntityConfigCleanup();

                populateAny(item[direction + 'Exception']);
                if(item[direction + 'Exception'].length === 1 && item[direction + 'Exception'][0].id === -1 ){
                    $scope.allowAnyItems = true;
                }
                else{
                    $scope.allowAnyItems = false;
                    item[direction + 'Exception'].forEach(function (singleFrom) {
                        $scope.addEntityConfig.ips = item[direction  + 'Exception'].filter(function (from) {return from.type === "IP"}).map(function (ip) {return ip.name}).join();
                        if (singleFrom.type != "IP") {
                            var config = getConfigFromType(singleFrom);
                            config.selectedItems.push(singleFrom);
                        }

                    });
                }

                $scope.entrySelectException = true;
                $scope.$root.openPopup("addItem");
            };

            /**
             * return the correct configuration according to the type
             * found on the item given
             * @param item
             * @returns {*}
             */
            function getConfigFromType(item) {
                if(item.type == 'SYSTEMGROUP'){
                    return $scope.addEntityConfig.groupsConfig;
                }
                if(item.type == 'GROUP'){
                    return $scope.addEntityConfig.groupsConfig;
                }
                else if(item.type == 'SITE'){
                    return $scope.addEntityConfig.sitesConfig;
                }
                else if(item.type == 'ACCESSLOGIN'){
                    return $scope.addEntityConfig.accessloginsConfig;
                }
                else if(item.type == 'IPRange' || item.type === 'SUBNET' || item.type === 'NETWORKINTERFACE' || item.type === 'INTERFACEIPRANGE'){
                    return $scope.addEntityConfig.ipRangesConfig;
                }
                else if(item.type == 'HOSTSUBNET'){
                    return $scope.addEntityConfig.subnetsConfig;
                }
                else if(item.type == 'FLOATINGIPSUBNET'){
                    return $scope.addEntityConfig.floatingIpsConfig;
                }
                else if(item.type == 'DIRECTORYSERVICEUSER') {
                    return $scope.addEntityConfig.dsUserConfig;
                }
            }

            /**
             * adding entities into the from property
             * of the rules
             */
            $scope.addFromItems = function () {
                if($scope.entrySelectException){
                    addFrom($scope.currentDirection === 'from' ? $scope.currentItem.fromException : $scope.currentItem.toException);
                }
                else{
                    addFrom($scope.currentItem[$scope.currentDirection]);
                }
            };

            /**
             * method for handling both kins of from receiving it a a parameter
             * @param currentFrom
             */
            function addFrom(currentFrom) {
                currentFrom.splice(0, currentFrom.length);
                if ($scope.allowAnyItems) {
                    currentFrom.push({"id": -1, "name": "Any", "display_name": "Any"});
                }

                var itemTypes = ['groups', 'sites', 'subnets', 'accesslogins', 'ipRanges', 'dsUser', 'ifaces','floatingIps'];
                for (var key in itemTypes) {
                    var config = $scope.addEntityConfig[itemTypes[key] + 'Config'];
                    if (!$scope.allowAnyItems) {
                        // enter all content into the array
                        config.selectedItems.forEach(function (item) {
                            if (itemTypes[key] === 'floatingIps') {
                                updateFloatingIpParameters(item);
                            }
                            currentFrom.push(item);
                        });
                    }
                    config.selectedItems = [];
                }
                if ($scope.addEntityConfig.ips) {
                    $scope.addEntityConfig.ips.split(",").forEach(function (ip) {
                        if (ip.trim().length > 0)
                            if (!_.find(currentFrom, {'id': ip.trim()}))
                                currentFrom.push({"id": 0, "name": ip.trim(), "type": "IP"});
                    });
                }
                $scope.$root.closePopup('addItem');
            }

            	 //updates floating ip display_name if doesn't exist
            	 function updateFloatingIpParameters(item){
                    item.display_name = item.display_name ?  item.display_name : item.floatingRangeName;
                    item.entityType = 'floatingIps';
            	 }

            /**
             * if on the given item we don't have any of the properties described below
             * we create them and then assign them to the current object which will be available
             * upon selecting the add action
             * @param item
             */
            function initiateCurrentItems(item) {
                if (!item.what) {
                    item.what = [];
                }
                if (!item.fqdn) {
                    item.fqdns = [];
                }
                if (!item.topLevelDomains) {
                    item.topLevelDomains = [];
                }
                $scope.currentWhat = item.what;
                $scope.currentWhatException = item.whatException;
            }

            /**
             * this is a configuration for the route via location option
             * @type {{titleSearch: boolean, dataURL: dataURL, showTable: boolean, actions: Array, pageSize: number, sortField: string, searchField: string, fields: [*], type: string, selectedItems: Array}}
             */
            $scope.locationTableConfig= {
                titleSearch: true,
                dataURL : function(){
                    return "/getPopLocations?accountId=" + $state.params.accountId;
                },
                showTable: false,
                actions: [],
                pageSize:5,
                sortField:"name",
                searchField:"name",
                fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"}],
                type : "Location",
                selectedItems:[]
            };

            /**
             * this is the configuration for the allocated ips in the route and nat option
             * @type {{titleSearch: boolean, dataURL: dataURL, method: string, showTable: boolean, actions: Array, pageSize: number, fields: [*], type: string, processData: processData, selectedItems: Array}}
             */
            $scope.allocatedIpsTableConfig= {
                titleSearch: true,
                dataURL : function(){
                    return "/getAllocatedIps?accountId="+$state.params.accountId+"&fetchNatIps=true";
                },
                method: 'GET',
                showTable: false,
                actions: [],
                pageSize:5,
                fields : [
                    {"label":"Ip Address","path":"ip","template":"<span>{{item.ip}}</span>"},
                    {"label":"Type","path":"type","template":"<span>{{item.type | capitalize}}</span>"},
                    {"label":"Details","path":"location","template":"<span>{{(item.location || item.description) | capitalize}}</span>"}
                ],
                type : "Ip",
                processData: function(items) {
                    items.forEach(function (item) {
                        var location = LocationService.getPopLocationViaLocationId($state.params.accountId,item.locationId);
                        if(location && location.name){
                            item.location = location.name;
                        }
                    });
                },
                defer: true,
                selectedItems:[],
                clientSidePaging: true,
                clientSideSearch: true,
                clientSideSort: true,
            };

            /**
             * this is for the selection of location on the route options
             * @param id
             * @param item
             */
            $scope.locationEntryListSelect = function (id,item) {
            	if (!LocationService.hasLocationForAccount($state.params.accountId)) {
            		$timeout(function() {
                    	$scope.locationEntryListSelect(id,item);
                    }, 50, false);
                    return;
            	}
                $scope.currentItem = item;
                $scope.locationTableConfig.selectedItems = [];

                $scope.currentItem.locations.forEach(function (singleLocation) {
                    $scope.locationTableConfig.selectedItems.push(LocationService.getPopLocationViaLocationId($state.params.accountId,singleLocation.id));
                });
                $scope.$root.openPopup("selectLocationDlg");
            };

            /**
             * this is for the ip entry list selection where we select
             * allocated ip for the route and nat options
             * @param id
             * @param item
             */
            $scope.ipEntryListSelect = function (id,item) {
                $scope.currentItem = item;
                $scope.allocatedIpsTableConfig.selectedItems = [];

                if (item.allocatedIps) {
                    item.allocatedIps.forEach(function (allocatedIp) {
                        var selectedItem = {
                            description: allocatedIp.description,
                            id: LocationService.allocatedIpIdPrefix + allocatedIp.id,
                            locationId: allocatedIp.locationId,
                            location: allocatedIp.location,
                            ip: allocatedIp.ip,
                            type: 'ALLOCATED_IPS',
                        };

                        $scope.allocatedIpsTableConfig.selectedItems.push(selectedItem);
                    });
                }

                if (item.crossConnectNat) {
                    item.crossConnectNat.forEach(function (allocatedIp) {
                        var selectedItem = {
                            description: allocatedIp.description,
                            id: LocationService.publishedIpIdPrefix + allocatedIp.id,
                            location: allocatedIp.locationId,
                            ip: allocatedIp.ipRange,
                            type: 'PUBLISHED',
                        };

                        $scope.allocatedIpsTableConfig.selectedItems.push(selectedItem);
                    });
                }
                $scope.$root.openPopup("selectAllocatedIpsDlg");
            };

            /**
             * collect all location from table config and populate the correct item
             */
            $scope.addLocationItems =function () {
                $scope.currentItem.locations.splice(0,$scope.currentItem.locations.length);
                $scope.locationTableConfig.selectedItems.forEach(function (locationItem) {
                    $scope.currentItem.locations.push({id: locationItem.id,name: locationItem.name});
                });
                $scope.locationTableConfig.selectedItems = [];
                $scope.$root.closePopup('selectLocationDlg');
            };

            /**
             * collect all location from table config and populate the correct item
             */
            $scope.addAllocatedIp = function () {
                $scope.currentItem.allocatedIps = [];
                $scope.currentItem.crossConnectNat = [];
                if (!$scope.currentItem.allocatedIpsIds) {
                    $scope.currentItem.allocatedIpsIds = [];
                }
                if (!$scope.currentItem.publishedIpsIds) {
                    $scope.currentItem.publishedIpsIds = [];
                }
                $scope.currentItem.allocatedIpsIds.splice(0,$scope.currentItem.allocatedIpsIds.length);
                $scope.currentItem.publishedIpsIds.splice(0,$scope.currentItem.publishedIpsIds.length);
                $scope.currentItem.allocatedAndCrossConnectIps = [];
                $scope.allocatedIpsTableConfig.selectedItems.forEach(function (allocatedIp) {
                    setItemAllocatedIpAndCrossConnect($scope.currentItem, angular.copy(allocatedIp));
                });
                $scope.allocatedIpsTableConfig.selectedItems = [];
                $scope.$root.closePopup('selectAllocatedIpsDlg');
            };

            /**
             * setting the correct lists on the single network rules according to the selected
             * allocated ips and the cross connect ips
             * @param item
             * @param allocatedIp
             */
            function setItemAllocatedIpAndCrossConnect(item, allocatedIp) {
                if (allocatedIp.type === 'ALLOCATED_IPS') {
                    allocatedIp.id = allocatedIp.id.split("_")[2];
                    if (item.allocatedIps.indexOf(allocatedIp) <= -1) {
                        item.allocatedIps.push(allocatedIp);
                        item.allocatedAndCrossConnectIps.push(allocatedIp)
                    }
                    allocatedIp.display_name = getAllocatedIpDisplayName(allocatedIp);
                    item.allocatedIpsIds.push(allocatedIp.id);
                }
                else {
                    allocatedIp.id = allocatedIp.id.split("_")[1];
                    if (item.crossConnectNat.indexOf(allocatedIp) <= -1) {
                        item.crossConnectNat.push(allocatedIp);
                        item.allocatedAndCrossConnectIps.push(allocatedIp)
                    }
                    allocatedIp.display_name = allocatedIp.ip + ':Published';
                    item.publishedIpsIds.push(allocatedIp.id);
                }
            }

            /**
             * for adding the service (From) we use a number of table thus need
             * number of table configuration for each table this structure is used for convenience
             * that we we locate all the configurations together
             * @type {{appsConfig: {titleSearch: boolean, dataURL: dataURL, showTable: boolean, actions: Array, pageSize: number, sortField: string, searchField: string, fields: [*], type: string, selectedItems: Array}, servicesConfig: {titleSearch: boolean, dataURL: dataURL, showTable: boolean, actions: Array, pageSize: number, sortField: string, searchField: string, fields: [*], type: string, selectedItems: Array}, freeText: string, fqdnFreeText: string, ips: Array, newIPApplication: {}}}
             */
            $scope.addServiceConfig = {
                categoriesConfig: {
                    titleSearch: true,
                    dataURL : function(){
                        return "/categories?accountId=" + $state.params.accountId;
                    },
                    showTable: false,
                    actions: [],
                    pageSize:5,
                    sortField:"display_name",
                    searchField:"display_name",
                    fields : [{"label":"Name","path":"display_name","template":"<span>{{item.display_name}}</span>"}],
                    type : "AppCategory",
                    selectedItems:[]
                },
                appsConfig: {
                    titleSearch: true,
                    dataURL : function(){
                        return "/categories?accountId=" + $state.params.accountId;
                    },
                    showTable: false,
                    actions: [],
                    pageSize:5,
                    sortField:"display_name",
                    searchField:"display_name",
                    dataFilter : { field : "fw_type" },
                    fields : [{"label":"Name","path":"display_name","template":"<span>{{item.display_name}}</span>"},
                        {"label":"Categories","path":"categories","template":"<span>{{item.categoriesDisplay}}</span>"}],
                    type : "App",
                    selectedItems:[]
                },
                servicesConfig : {
                    titleSearch: true,
                    dataURL : function(){
                        return "/categories?accountId=" + $state.params.accountId;
                    },
                    showTable: false,
                    actions: [],
                    pageSize:5,
                    sortField:"display_name",
                    searchField:"display_name",
                    dataFilter : { field : "fw_type" },
                    fields : [{"label":"Name","path":"display_name","template":"<span>{{item.display_name}}</span>"},
                        {"label":"Categories","path":"categories","template":"<span>{{item.categoriesDisplay}}</span>"}],
                    type : "Service",
                    selectedItems:[]
                },
                freeText: "",
                fqdnFreeText: "",
                ips: [],
                newIPApplication: {},
                customAppsConfig: {
                    titleSearch: true,
                    dataURL : function () {
                        return "/getCustomApps?accountId=" + $state.params.accountId;
                    },
                    actions: [],
                    pageSize:5,
                    sortField:"name",
                    searchField:"name",
                    fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Category","path":"categoryId","template":"<span>{{item.categoryId | capitalize}}</span>"}],
                    type : "CustomApp",
                    parseData: function (data) {
                        var items = [];
                        for (var key in data) {
                            var item = data[key];
                            item.id = item.appId;
                            item.type = 'CustomApp';

                            item.display_name = item.name;
                            items.push(item);
                        }
                        return items;
                    },
                    selectedItems:[]
                },
                customCategoriesConfig: {
                    titleSearch: true,
                    dataURL : function () {
                        return "/getCustomCategories?accountId=" + $state.params.accountId;
                    },
                    actions: [],
                    pageSize:5,
                    sortField:"name",
                    searchField:"name",
                    fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Description","path":"description","template":"<span>{{item.description}}</span>"}],
                    type : "CustomCategory",
                    parseData: function (data) {
                        var items = [];
                        for (var key in data) {
                            var item = data[key];
                            item.display_name = item.name;
                            items.push(item);
                        }
                        return items;
                    },
                    selectedItems:[]
                },
            };

            /**
             * populate the any property according to the content
             * found in the items array
             * @param items
             */
            function populateAny(items) {
                $scope.allowAnyItems = !!(items.length == 1 && items[0].id == -1);
            }

            /**
             * method for initiating the properties of the addServiceConfig
             * this properties will be initiated to empty values
             */
            function initiateAddServiceConfigProperties() {
                // when opening the dialog - check all existing items
                $scope.addServiceConfig.categoriesConfig.selectedItems = [];
                $scope.addServiceConfig.appsConfig.selectedItems = [];
                $scope.addServiceConfig.servicesConfig.selectedItems = [];
                $scope.addServiceConfig.newIPApplication.ips = "";
                $scope.addServiceConfig.newIPApplication.autoGeneratedIPSec = "";
                $scope.addServiceConfig.freeText = "";
                $scope.addServiceConfig.fqdnFreeText = "";
                $scope.addServiceConfig.ports = "";
                $scope.addServiceConfig.allowAnyItems = false;
                $scope.addServiceConfig.customAppsConfig.selectedItems = [];
                $scope.addServiceConfig.customCategoriesConfig.selectedItems = [];
            }

            /**
             * this function will be called upon selecting the what entry
             * list add icon
             * @param id
             * @param item
             */
            $scope.whatEntryListSelect = function (id,item) {
                initiateCurrentItems(item);
                populateAny(item.what);
                // setting the default category for the services dialog
                $scope.showAllocatedIps='categories';
                $scope.addServiceConfig.appsConfig.dataFilter.selectedOption = item.toType;
                $scope.addServiceConfig.servicesConfig.dataFilter.selectedOption = item.toType;
                $scope.appsDataModified = new Date().getTime();
                $scope.servicesDataModified = new Date().getTime();
                initiateAddServiceConfigProperties();

                /*
                 * this section is responsible for filling the
                 * addServiceConfig properties after we initiated them in
                 * initiateAddServiceConfigProperties
                 */
                item.what.forEach(function(service){
                    if(!service.ip && service.display_name != 'Any' ){
                        if (service.type === 'Service') {
                            // Service
                            $scope.addServiceConfig.servicesConfig.selectedItems.push(service);
                        } else if(service.type === 'AppCategory'){
                            // Category
                            $scope.addServiceConfig.categoriesConfig.selectedItems.push(service);
                        } else if (service.type === 'CustomApp') {
                            $scope.addServiceConfig.customAppsConfig.selectedItems.push(service);
                        } else if (service.type === 'CustomCategory') {
                            $scope.addServiceConfig.customCategoriesConfig.selectedItems.push(service);
                        } else if (service.type != 'FQDN' && service.type != 'TLD' && service.type != 'PORT') {
                            // APP
                            service.type = 'App'; // Fill type on existing configuration
                            $scope.addServiceConfig.appsConfig.selectedItems.push(service);

                        }
                    }
                });
                $scope.addServiceConfig.freeText = item.what.filter(function (dest) {return dest.type === "TLD"}).map(function (dest) {return dest.id}).join();
                $scope.addServiceConfig.fqdnFreeText = item.what.filter(function (dest) {return dest.type === "FQDN"}).map(function (dest) {return dest.id}).join();
                $scope.addServiceConfig.ports = item.what.filter(function (dest) {return dest.type === "PORT"}).map(function (dest) {return dest.port}).join();
                // only the custom generated
                $scope.addServiceConfig.newIPApplication.ips = item.what.filter(function(serv) {return serv.ip && !serv.autoGenerated;}).map(function (service) {return service.display_name;}).join();
                // only the auto generated for ipsec services
                $scope.addServiceConfig.newIPApplication.autoGeneratedIPSec = item.what.filter(function(serv) {return serv.ip && serv.autoGenerated;}).map(function (service) {return service.display_name;}).join();

                $scope.entrySelectException = false;
                $scope.currentItem = item;
                $scope.$root.openPopup("networkingRulesServicesDlg");
            };

            /**
             * this method for selecting the from entry list selection open the popup and initiating the
             * properties
             * @param id
             * @param item
             * @param direction
             */
            $scope.fromEntryListSelect =  function (id, item, direction) {
                $scope.showItem = 'group';

                $scope.currentItem = item;
                $scope.currentDirection = direction;

                initiateCurrentItems(item);
                populateAny(item[direction]);

                performAddEntityConfigCleanup();

                if(item[direction].length == 1 && item[direction][0].id ==-1 ){
                    $scope.allowAnyItems = true;
                }
                else{
                    $scope.allowAnyItems = false;
                    item[direction].forEach(function (singleFrom) {
                        $scope.addEntityConfig.ips = item[direction].filter(function (from) {return from.type === "IP"}).map(function (ip) {return ip.name}).join();
                        if (singleFrom.type != "IP") {
	                        var config = getConfigFromType(singleFrom);
	                        config.selectedItems.push(singleFrom);
                        }
                    });
                }

                $scope.entrySelectException = false;
                $scope.$root.openPopup("addItem");
            };

            function performAddEntityConfigCleanup(){
                $scope.addEntityConfig.groupsConfig.selectedItems = [];
                $scope.addEntityConfig.sitesConfig.selectedItems = [];
                $scope.addEntityConfig.accessloginsConfig.selectedItems = [];
                $scope.addEntityConfig.ipRangesConfig.selectedItems = [];
                $scope.addEntityConfig.subnetsConfig.selectedItems = [];
                $scope.addEntityConfig.floatingIpsConfig.selectedItems = [];
                $scope.addEntityConfig.dsUserConfig.selectedItems = [];
                $scope.addEntityConfig.ips = "";
            }


            /**
             * for the from adding we display a number of table in the pop up each of them needed a confgiuration
             * here we aggregate all of the configurations
             * @type {{groupsConfig: {fixedLayout: boolean, titleSearch: boolean, dataURL: dataURL, showTable: boolean, fields: [*], type: string, actions: Array, selectedItems: Array, pageSize: number, clientSidePaging: boolean, clientSideSearch: boolean, clientSideSort: boolean}, sitesConfig: {fixedLayout: boolean, titleSearch: boolean, dataURL: dataURL, showTable: boolean, fields: [*], type: string, actions: Array, selectedItems: Array, pageSize: number}, subnetsConfig: {titleSearch: boolean, dataURL: dataURL, showTable: boolean, fields: [*], type: string, actions: Array, selectedItems: Array, pageSize: number}, ifacesConfig: {fixedLayout: boolean, titleSearch: boolean, dataURL: dataURL, showTable: boolean, fields: [*], type: string, actions: Array, selectedItems: Array, pageSize: number}, accessloginsConfig: {titleSearch: boolean, statusNames: {DISABLED: string, ACTIVE: string, SUSPENDED: string, NEW: string, PENDING_USER_CONFIGURATION: string}, loginNameById: {}, dataURL: dataURL, fields: [*], type: string, actions: Array, selectedItems: Array, pageSize: number}, ipRangesConfig: {fixedLayout: boolean, titleSearch: boolean, dataURL: dataURL, showTable: boolean, fields: [*], type: string, actions: Array, selectedItems: Array, pageSize: number}, dsUserConfig: {titleSearch: boolean, accountId, dataURL: dataURL, fields: [*], processData: processData, type: string, actions: Array, selectedItems: Array, pageSize: number}}}
             */
            $scope.addEntityConfig = {
                groupsConfig : {
                    fixedLayout: true,
                    titleSearch: true,
                    dataURL: function () {
                        return '/groups?accountId=' + $state.params.accountId;
                    },
                    showTable: false,
                    fields: [{ label: 'Name', path: 'name', template: '<span>{{item.prefix}}{{item.name}}</span>' },
                        { label: 'Description', path: 'description', template: '<span>{{item.description}}</span>' },
                    ],
                    type: 'Group',
                    actions: [],
                    selectedItems: [],
                    pageSize: 5,
                },
                sitesConfig : {
                    fixedLayout: true,
                    titleSearch: true,
                    dataURL: function () {
                        return '/sites?accountId=' + $state.params.accountId;
                    },
                    showTable: false,
                    fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
                        { label: 'Address', path: 'address', template: '<span>{{item.address}}</span>' },
                    ],
                    type: 'Site',
                    actions: [],
                    selectedItems: [],
                    pageSize: 5,
                },
                subnetsConfig : {
                    titleSearch: true,
                    dataURL : function(){
                        var accountId = $scope.currentAccountId || $state.params.accountId;
                        if ($scope.site && $scope.site.id)
                            return "/subnets?siteId=" + $scope.site.id;
                        return "/subnets?accountId=" + accountId;
                    },
                    showTable: false,
                    fields :[
                        {"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},
                        {"label":"Site","path":"siteName","template":"<span>{{item.siteName}}</span>"},
                        {"label":"Network","path":"interfaceName","template":"<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>"},
                        {"label":"IP","path":"subnet","template":"<span>{{item.translatedSubnet}}</span>"}
                    ],
                    type : "Subnet",
                    actions: [],
                    selectedItems:[],
                    pageSize:5
                },
                ifacesConfig : {
                    fixedLayout: true,
                    titleSearch: true,
                    dataURL: function () {
                        if ($scope.site && $scope.site.id)
                            return "/getInterfaces?siteId=" + $scope.site.id;
                        return '/getInterfaces?accountId=' + $state.params.accountId;
                    },
                    showTable: false,
                    fields: [{ label: 'Name', path: 'name', template: '<span>{{item["display_name"] || item.name}}</span>' },
                        { label: 'Destination', path: 'siteName', template: '<span>{{item.destType.value | capitalize}}</span>' },
                        { label: 'Interface ', path: 'interfaceName', template: '<span>{{item.interface_id}}</span>' }
                    ],
                    type: 'IPRange',
                    actions: [],
                    selectedItems: [],
                    pageSize: 5
                },
                accessloginsConfig : {
                    titleSearch: true,
                    statusNames: { DISABLED: 'Disabled', ACTIVE: 'Configured', SUSPENDED: 'Suspended', NEW: 'New', PENDING_USER_CONFIGURATION: 'Invitation Sent' },
                    loginNameById: {},
                    dataURL: function () {
                        return '/logins?accountId=' + $state.params.accountId;
                    },
                    fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}<span>' },
                        { label: 'E-mail', path: 'email' },
                    ],
                    type: 'AccessLogin',
                    actions: [],
                    selectedItems: [],
                    pageSize: 5,
                },
                ipRangesConfig : {
                    fixedLayout: true,
                    titleSearch: true,
                    dataURL: function () {
                        if ($scope.site && $scope.site.id)
                            return "/getNetworks?isRequestFromOFE=1&siteId=" + $scope.site.id;
                        return '/getNetworks?isRequestFromOFE=1&accountId=' + $state.params.accountId;
                    },
                    showTable: false,
                    fields: [
                        {label: 'Name', path: 'name', template: '<span>{{item.name}}</span>'},
                        { label: 'Site', path: 'siteName', template: '<span>{{item.siteName}}</span>' },
                        { label: 'Interface', path: 'interfaceName', template: '<span>{{item.interfaceName}}</span>' },
                        { label: 'Type', path: 'subnetType', template: '<span>{{item.subnetType | capitalize}}</span>' },
                        { label: 'Range', path: 'subnet', template: '<span>{{item.subnet}}</span>' },
                    ],
                    type: 'IPRange',
                    actions: [],
                    selectedItems: [],
                    pageSize: 5
                },
                dsUserConfig : {
                    titleSearch: true,
                    accountId: $state.params.accountId,
                    dataURL : function(){
                        return "/getAllDsUsers?accountId=" + $state.params.accountId;
                    },
                    fields : [{"label":"Name","path":"Login Name","template":"<span>{{item.loginName}}</span>"},
                        {"label":"Subnet","path":"Full Name","template":"<span>{{item.fullName}}</span>"}
                    ],
                    processData: function(items){
                    },
                    type : "DsUser",
                    actions: [],
                    selectedItems:[],
                    pageSize:5
                },
                floatingIpsConfig: {
                        titleSearch: true,
                        fixedLayout: true,
                        accountId: $state.params.accountId,
                        method: 'GET',
                        dataURL : function(){
                            return "/getFloatingIps?accountId=" + $state.params.accountId;
                        },
                        fields : [
                            {label: 'Name', path: 'floatingRangeName', template: '<span>{{item.floatingRangeName}}</span>'},
                            {label:"IP Range","path":"subnet",template:"<span>{{item.subnet}}</span>"}],
                        processData: function(items){
                        },
                        type : "floatingips",
                        actions: [],
                        selectedItems:[],
                        pageSize:5,
                        clientSidePaging: true,
                        clientSideSearch: true,
                        clientSideSort: true
                    }
            };

            /**
             * adding the services into the what category
             * this will be applied when closing the dialog we want to collect
             * into the "what" attribute of the table item
             */
            $scope.addWhatServices = function() {
                if($scope.entrySelectException){
                    handleWhatService($scope.currentItem.whatException);
                }
                else{
                    handleWhatService($scope.currentItem.what);
                }
            };

            /**
             * method for filling the app config
             * @param currentWhat
             */
            function fillCategoryConfig(currentWhat) {
                // Apps
                $scope.addServiceConfig.categoriesConfig.selectedItems.forEach(function (category) {
                    if (currentWhat.indexOf(category) < 0) {
                        category.type = "AppCategory";
                        currentWhat.push(category);
                    }
                });
            }

            /**
             * method for filling the app config
             * @param currentWhat
             */
            function fillAppConfig(currentWhat) {
                // Apps
                $scope.addServiceConfig.appsConfig.selectedItems.forEach(function (service) {
                    if (currentWhat.indexOf(service) < 0) {
                        service.type = "App";
                        currentWhat.push(service);
                    }
                });
            }

            /**
             * method for filling the services config
             * @param currentWhat
             */
            function fillServicesConfig(currentWhat) {
                // services
                $scope.addServiceConfig.servicesConfig.selectedItems.forEach(function (service) {
                    if (currentWhat.indexOf(service) < 0) {
                        service.type = "Service";
                        currentWhat.push(service);
                    }
                });


                $scope.addServiceConfig.customAppsConfig.selectedItems.forEach(function (app) {
                    if (currentWhat.indexOf(app) < 0) {
                        app.type = 'CustomApp';
                        if(app.appId){
                            app.id = app.appId;
                        }
                        if (app.definitions) {
                            delete app.definitions;
                        }
                        currentWhat.push(app);
                    }
                });
                $scope.addServiceConfig.customCategoriesConfig.selectedItems.forEach(function (app) {
                    if (currentWhat.indexOf(app) < 0) {
                        app.type = 'CustomCategory';
                        currentWhat.push(app);
                    }
                });

                if ($scope.addServiceConfig.freeText) {
                    $scope.addServiceConfig.freeText.split(",").forEach(function (tld) {
                        if (tld.trim().length > 0)
                            if (!_.find(currentWhat, {'id': tld.trim()}))
                                currentWhat.push({"id": tld.trim(), "name": tld.trim(), "type": "TLD"});
                    });
                }
                if ($scope.addServiceConfig.fqdnFreeText) {
                    $scope.addServiceConfig.fqdnFreeText.split(",").forEach(function (fqdn) {
                        if (fqdn.trim().length > 0)
                            if (!_.find(currentWhat, {'id': fqdn.trim()}))
                                currentWhat.push({"id": fqdn.trim(), "name": fqdn.trim(), "type": "FQDN"});
                    });
                }
                if ($scope.addServiceConfig.ports) {
                    $scope.addServiceConfig.ports.split(",").forEach(function (port) {
                        if (port.trim().length > 0)
                            if (!_.find(currentWhat, {'id': port.trim()}))
                                currentWhat.push({"id": port.trim(), "name": port.trim(), "type": "PORT"});
                    });
                }

            }

            /**
             * method for handling the what property we receive the currentWhat as parameter
             * since we want to use the same function for whatExceptions and what
             * @param currentWhat
             */
            function handleWhatService(currentWhat) {
                var ok = true;

                currentWhat.length = 0;
                if ($scope.allowAnyItems) {
                    currentWhat.push({"id": -1, "display_name": "Any", type:"what"});
                }
                else {
                    fillAppConfig(currentWhat);
                    fillServicesConfig(currentWhat);
                    fillCategoryConfig(currentWhat);


                    // IPs
                    if ($scope.addServiceConfig.newIPApplication.ips) {
                        var ips = $scope.addServiceConfig.newIPApplication.ips.split(",");
                        ips.forEach(function (ipStr) {
                            if (!ipStr || ipStr === '') return;
                            if (ipStr.indexOf(":") < 0) {
                                ok = false;
                                alert("Incorrect format for custom service, please enter <name>:<ip address> (sampleservice:10.10.10.1,newservice:20.20.20.8)");
                            }
                            if (ok) {
                                var ipSplitted = ipStr.split(":");
                                currentWhat.push({
                                    "id": ipSplitted[1],
                                    "display_name": ipSplitted[0] + ":" + ipSplitted[1],
                                    "ip": ipSplitted[1],
                                    "autoGenerated": false,
                                    desc: ipSplitted[0],
                                });
                            }
                        });
                    }
                    if ($scope.addServiceConfig.newIPApplication.autoGeneratedIPSec) {
                        var autoGeneratedIPSec = $scope.addServiceConfig.newIPApplication.autoGeneratedIPSec.split(",");
                        autoGeneratedIPSec.forEach(function (ipStr) {
                            var ipSplitted = ipStr.split(":");
                            currentWhat.push({
                                "id": ipSplitted[1],
                                "display_name": ipSplitted[0] + ":" + ipSplitted[1],
                                "ip": ipSplitted[1],
                                "autoGenerated": true,
                                desc: ipSplitted[0],
                            });
                        });
                    }
                }
                if (ok) {
                    $scope.$root.closePopup('networkingRulesServicesDlg');
                }
            }
        }]
    };
});
